import 'react-toastify/dist/ReactToastify.css';
import ReactGA from 'react-ga4';
// TODO: Enable i18n in the future
// import './i18n';

import { QueryClientProvider } from '@tanstack/react-query';
import { ReactNode, useEffect, useRef } from 'react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ToastContainer } from 'react-toastify';
import { useIsMobile } from 'utils/useIsMobile';
import { queryClient } from 'query-client';
import logo from './logo.svg';

import PWAInstall from '@khmyznikov/pwa-install/react-legacy';
import { PWAInstallElement } from '@khmyznikov/pwa-install';

process.env.REACT_APP_GOOGLE_ANALYTICS_ID &&
  ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_ID);

interface AppProps {
  children: ReactNode;
}

export const App = ({ children }: AppProps) => {
  const isMobile = useIsMobile();
  const pwaInstallRef = useRef<PWAInstallElement>(null);

  const showPwaOption =
    isMobile && !window.matchMedia('(display-mode: standalone)').matches;

  useEffect(() => {
    window.addEventListener('beforeinstallprompt', (event) => {
      event.preventDefault(); // Prevent auto prompt
      console.log('PWA Install Prompt captured:', event);
    });

    if (pwaInstallRef.current) {
      pwaInstallRef.current.install();
    }
  }, []);

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools />
        {children}
        <ToastContainer
          position={isMobile ? 'top-right' : 'bottom-right'}
          limit={isMobile ? 1 : 2}
        />
      </QueryClientProvider>
      {showPwaOption ? (
        <PWAInstall
          ref={pwaInstallRef}
          description="Installer Smart Create som app, og få nem adgang til dine værktøjer direkte fra din enhed."
          manifestUrl="/manifest.json"
          icon={logo}
        />
      ) : null}
    </>
  );
};
